import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=19bd0ffc&scoped=true&"
import script from "./CartIcon.vue?vue&type=script&lang=js&"
export * from "./CartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd0ffc",
  null
  
)

export default component.exports